import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import RaceMeetingPageViewImpl from './race-meeting-page-view.js';

const UIView = MojitoCore.Presentation.UIView;

/**
 * View that layouts the content of a meeting page for a racing sport.
 *
 * @class RaceMeetingPageView
 * @memberof Mojito.Applications.Sports.Pages.RaceMeetingPage
 */

/**
 * RaceMeetingPageView prop types.
 *
 * @property {string} sportId - The sportId to display.
 * @property {string} meetingId - The meetingId to display. If the id includes any '-', it consists of more than one meeting grouped together.
 * @property {Array} [meetings] - Associative array containing all meetings.
 * @property {string} [raceId] - The raceId to display. If not set, all events for the meeting will be displayed.
 *
 * @memberof Mojito.Applications.Sports.Pages.RaceMeetingPage.RaceMeetingPageView
 */
const propTypes = {
    sportId: PropTypes.string.isRequired,
    meetingId: PropTypes.string.isRequired,
    meetings: PropTypes.array,
    raceId: PropTypes.string,
};

export default UIView('RaceMeetingPageView', RaceMeetingPageViewImpl, propTypes);
